import { type RefObject, useEffect, useState } from "react";

import { mostVisiblePage } from "./visible_page";

const THRESHOLDS = [0, 0.25, 0.5, 0.75, 1];

// "Page X of N": which page of the scrolling report is most in view. An
// IntersectionObserver, not a scroll listener. Re-observes when `pagesKey`
// changes (another file, or its pages arrived).
export const useVisiblePage = (
  ref: RefObject<HTMLElement | null>,
  pagesKey: string,
) => {
  const [page, setPage] = useState<number | null>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const ratios = new Map<number, number>();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const number = Number((entry.target as HTMLElement).dataset.page);
          ratios.set(number, entry.intersectionRatio);
        }
        setPage(mostVisiblePage(ratios));
      },
      { root, threshold: THRESHOLDS },
    );
    root.querySelectorAll("[data-page]").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [ref, pagesKey]);

  return page;
};
